import React from 'react'
import PropTypes from 'prop-types'
import EditIcon from '@mui/icons-material/Edit'
import { format } from 'date-fns'

import { ContentRow, TemplateNameColumn, TemplateDateColumn, TemplateActionContainer } from '../styles/TableStyles'
import { MedBodyText, BoldMedBodyText } from '../styles/Text'
import { SecondaryIconButton } from '../common/Button'

const formatDate = date => {
  return format(date, 'MMM-dd-yyyy')
}
const formatTime = date => {
  return format(date, 'hh:mm a')
}

function LetterTemplateRow({ letterTemplate, onEditLetterTemplate = () => {}, handleSelectTemplate = () => {} }) {
  function handleSelect() {
    handleSelectTemplate(letterTemplate.id)
  }

  function handleRowKeyDown(event) {
    if (event.target !== event.currentTarget) return

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleSelect()
    }
  }

  function handleEditClick(event) {
    event.stopPropagation()
    onEditLetterTemplate(letterTemplate.id)
  }

  return (
    <ContentRow role="button" tabIndex={0} onClick={handleSelect} onKeyDown={handleRowKeyDown}>
      <TemplateNameColumn>
        <BoldMedBodyText>{letterTemplate.name}</BoldMedBodyText>
      </TemplateNameColumn>
      <TemplateDateColumn>
        <BoldMedBodyText>{formatDate(letterTemplate.updatedAt)}</BoldMedBodyText>
        <MedBodyText>{formatTime(letterTemplate.updatedAt)}</MedBodyText>
      </TemplateDateColumn>
      <TemplateActionContainer>
        <SecondaryIconButton onClick={handleEditClick} aria-label={`Edit letter template ${letterTemplate.name}`}>
          <EditIcon />
        </SecondaryIconButton>
      </TemplateActionContainer>
    </ContentRow>
  )
}

LetterTemplateRow.propTypes = {
  letterTemplate: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    updatedAt: PropTypes.instanceOf(Date).isRequired
  }).isRequired,
  onEditLetterTemplate: PropTypes.func,
  handleSelectTemplate: PropTypes.func
}

export default LetterTemplateRow
